import { render, staticRenderFns } from "./SpecimensToPublic.vue?vue&type=template&id=24ad2312"
import script from "./SpecimensToPublic.vue?vue&type=script&lang=js"
export * from "./SpecimensToPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports